import styles from "./generator.module.scss";
import dynamic from "next/dynamic";

// Dynamically import Product
const Product = dynamic(() => import("./product"), {
  loading: () => <p>Loading produkt...</p>, // Optional: skeleton or spinner
  ssr: false, // Set to false if Product uses browser-only APIs
});

export default function ProductList({ shuffledProducts }) {
  return (
    <div className={styles.productList}>
      {shuffledProducts.map((data, i) => (
        <Product data={data} key={i} />
      ))}
    </div>
  );
}
